export default [{
  path: '/sanction-type',
  name: 'sanctionType',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/sanctionType/index')
}]
